// src/components/admin/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  const navLinkClasses = (path) =>
    `px-4 py-2 rounded-md ${
      isActive(path)
        ? 'bg-gray-700 text-white'
        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
    }`;

  return (
    <header className="bg-gray-800 p-4 shadow-md">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-lg font-bold text-white mr-8">Admin Dashboard</h1>
          <nav className="flex space-x-4">
            <Link to="/admin/dashboard" className={navLinkClasses('/admin/dashboard')}>
              Dashboard
            </Link>
            <Link to="/admin/users" className={navLinkClasses('/admin/users')}>
              Users
            </Link>
            <Link to="/admin/blogs" className={navLinkClasses('/admin/blogs')}>
              Blogs
            </Link>
            <div className="relative group">
              <Link
                to="/admin/company/settings"
                className={`${navLinkClasses('/admin/company')} inline-flex items-center`}
              >
                Company
                <svg className="ml-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
              <div className="absolute hidden group-hover:block w-48 bg-white rounded-md shadow-lg py-1 mt-1">
                <Link
                  to="/admin/company/settings"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Settings 
                </Link>
                <Link
                  to="/admin/company/contact-info"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Contact Info
                </Link>
                <Link
                  to="/admin/company/who-we-are"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Who We Are
                </Link>
                <Link
                  to="/admin/company/services"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Our Services
                </Link>
                <Link
                  to="/admin/company/social"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Social Links
                </Link>
                <Link
                  to="/admin/company/description"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Description
                </Link>
              </div>
            </div>
            <Link to="/admin/media" className={navLinkClasses('/admin/media')}>
              Media
            </Link>
          </nav>
        </div>

        <div className="relative">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center space-x-2 text-gray-300 hover:text-white focus:outline-none"
          >
            <img
              className="h-8 w-8 rounded-full"
              src="https://media.licdn.com/dms/image/v2/D5603AQHEgy7905RrRw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1718597947549?e=2147483647&v=beta&t=9YpcOQHT7NaYu3nQpcZbKoWfw4uM4THgGlY_ql6UFvs"
              alt="Profile"
            />
            <span>Admin</span>
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 rounded-md bg-white py-2 shadow-lg ring-1 ring-black ring-opacity-5">
              <Link
                to="/admin/profile"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                My Profile
              </Link>
              <Link
                to="/admin/account"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Account Settings
              </Link>
              <Link
                to="/admin/settings"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                System Settings
              </Link>
              <div className="border-t border-gray-100 my-1"></div>
              <button
                onClick={() => {
                  localStorage.removeItem('token');
                  localStorage.removeItem('username');
                  localStorage.removeItem('role');
                  window.location.href = '/login';
                }}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
